import React from 'react';
import { useApp } from '../../../context/AppContext';
import useAppSettings from '../../../hooks/useAppSettings';
import LoadingScreen from '../../common/LoadingScreen/LoadingScreen';
import useAnalytics from '../../../hooks/useAnalytics';
import Logo from '../../common/Logo/Logo';


import './HomeScreen.scss';

const HomeScreen = () => {
  const { actions } = useApp();
  const { homepageData, loading, error } = useAppSettings();
  const { trackBoadingPassInitLoad, trackMainMenuClick } = useAnalytics();


  const handleBoardingPassStart = () => {
    trackMainMenuClick('boarding_pass');
    actions.setView('boarding-pass-flow');
    trackBoadingPassInitLoad();
  };

  const handleGameStart = (gameNumber) => {
    if (gameNumber) {
      if (gameNumber === 1) {
        trackMainMenuClick('ascend');
      } else if (gameNumber === 2) {
        trackMainMenuClick('rail_inspection');
      } else if (gameNumber === 3) {
        trackMainMenuClick('viewfinder');
      }
    }

    actions.setView(`game-${gameNumber}`);
  };

  if (loading) {
    return <LoadingScreen message="Loading experience..." />;
  }

  return (
    <div className="home-screen">
      <div className="home-screen__container">
        <div className="home-screen__header">
          <h1 className="home-screen__title">
            {homepageData?.home_boarding_pass_title || 'Welcome to Level 62'}
          </h1>
          <p className="home-screen__subtitle">
            {homepageData?.home_subtitle || "Let's prepare for your journey."}
          </p>

          {error && (
            <p className="home-screen__fallback-notice">
              Using default content (WordPress connection issue)
            </p>
          )}
        </div>

        <div className="home-screen__options">
          <div
            className="experience-card boarding-pass-card"
            onClick={handleBoardingPassStart}
          >
            <div className="card__background">
              <img
                src={homepageData?.boarding_pass_button_background?.url}
                alt=""
                className="background-image"
              />
            </div>
            <div className="card__content">
              <div className="card__header">
                <span className="card__category">
                  {homepageData?.boarding_pass_button_subtitle ||
                    'GET READY TO BOARD'}
                </span>
                <h2 className="card__title">
                  {homepageData?.boarding_pass_button ||
                    'Level 62 Boarding Pass'}
                </h2>
              </div>
              <div className="card__footer">
                <div className="card__cta">
                  <span>
                    {homepageData?.boarding_pass_button_description ||
                      'Start Journey'}
                  </span>
                  <svg
                    width="27"
                    height="11"
                    viewBox="0 0 27 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26.5209 5.83145C26.803 5.54929 26.803 5.09183 26.5209 4.80967L21.9229 0.211698C21.6408 -0.0704565 21.1833 -0.0704566 20.9011 0.211698C20.619 0.493853 20.619 0.951315 20.9011 1.23347L24.9882 5.32056L20.9011 9.40765C20.619 9.6898 20.619 10.1473 20.9011 10.4294C21.1833 10.7116 21.6408 10.7116 21.9229 10.4294L26.5209 5.83145ZM0 5.32056L-6.31631e-08 6.04306L26.01 6.04306L26.01 5.32056L26.01 4.59806L6.31631e-08 4.59805L0 5.32056Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <div className="games-section">
            <div
              className="experience-card ascend-card"
              onClick={() => handleGameStart(1)}
            >
              <div className="card__content">
                <div className="card__header">
                  <h2 className="card__title">
                    {homepageData?.mini_games?.[0]?.game_title || 'Ascend'}
                  </h2>
                </div>
                <div className="card__footer">
                  <div className="card__cta">
                    <span>
                      {homepageData?.mini_games?.[0]?.game_description ||
                        'Ascend'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="games-grid">
              <div
                className="experience-card railing-card"
                onClick={() => handleGameStart(2)}
              >
                <div className="card__content">
                  <div className="card__header">
                    <h2 className="card__title">
                      {homepageData?.mini_games?.[1]?.game_title ||
                        'Railing Repair'}
                    </h2>
                  </div>
                  <div className="card__footer">
                    <div className="card__cta">
                      <span>
                        {homepageData?.mini_games?.[1]?.game_description ||
                          "Strengthen the elevator's rails for a secure journey."}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="experience-card viewfinder-card"
                onClick={() => handleGameStart(3)}
              >
                <div className="card__content">
                  <div className="card__header">
                    <h2 className="card__title">
                      {homepageData?.mini_games?.[2]?.game_title ||
                        'Viewfinder'}
                    </h2>
                  </div>
                  <div className="card__footer">
                    <div className="card__cta">
                      <span>
                        {homepageData?.mini_games?.[2]?.game_description ||
                          'Test your memory to reveal the view.'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="slides-topbar-main home">
        <div className="logo-group logo-group--main">
          <div className="logo logo-main-container">
            <Logo
              className="logo-main"
              src={homepageData?.level_62_logo_black?.url}
              alt={homepageData?.level_62_logo_black?.alt}
            />
          </div>
        </div>
        <div className="logo-group logo-group--accents">
          <div className="logo logo-accent-container logo-sf">
            <Logo
              className="logo-accent"
              src={homepageData?.spaceforce_icon_black?.url}
              alt={homepageData?.spaceforce_icon_black?.alt}
              loading="lazy"
            />
          </div>
          <div className="logo logo-accent-container logo-62">
            <Logo
              className="logo-accent"
              src={homepageData?.level_62_icon_black?.url}
              alt={homepageData?.level_62_icon_black?.alt}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
